import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { LogoutService } from './logout.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private idleStartSubject = new Subject<void>();
  public onIdleStart$ = this.idleStartSubject.asObservable();

  constructor(
    private idle: Idle,
    private logoutService: LogoutService
  ) {
    this.configureIdle();
  }

  private configureIdle(): void {
    this.idle.setTimeout(30);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // Emit event when user starts idling
    this.idle.onIdleStart.subscribe(() => {
      this.idleStartSubject.next();
    });

    this.idle.onTimeout.subscribe(() => {
      // Same flow as the manual sign-out, so federated users also get their IDP session closed
      this.logoutService.logout({ reason: 'logged_out_due_to_inactivity' });
    });
  }

  /**
   * Start watching for user idle activity
   */
  startWatching(idleTimeout: number): void {
    this.idle.setIdle(idleTimeout * 60); // Convert minutes to seconds
    this.idle.watch();
  }

  /**
   * Stop watching for user idle activity
   */
  stopWatching(): void {
    this.idle.stop();
  }

  /**
   * Get the status of the idle watcher
   */
  isIdling(): boolean {
    return this.idle.isIdling();
  }
}
